/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { ComboBoxOption } from '@marageti/z4-lib';
import { FiltersState, StatusFilter } from './types';

const STATUS_OPTIONS: { label: string; value: StatusFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

type DestinationFiltersProps = {
  countryOptions: ComboBoxOption[];
  filters: FiltersState;
  onChangeNameFilter: (value: string) => void;
  onChangeCountryFilter: (value: ComboBoxOption | null) => void;
  onChangeStatusFilter: (value: StatusFilter) => void;
};

const DestinationFilters = ({
  countryOptions,
  filters,
  onChangeNameFilter,
  onChangeCountryFilter,
  onChangeStatusFilter,
}: DestinationFiltersProps) => (
  <Stack
    direction={{ mobile: 'column', desktop: 'row' }}
    spacing={2}
    marginBottom={3}
    alignItems="flex-start"
  >
    <TextField
      label="Search"
      value={filters.nameFilter}
      onChange={(e) => onChangeNameFilter(e.target.value)}
      size="small"
      sx={{ minWidth: 200 }}
    />
    <Autocomplete
      options={countryOptions}
      getOptionLabel={(option: ComboBoxOption) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      value={filters.countryFilter}
      onChange={(_, data) => onChangeCountryFilter(data)}
      renderInput={(params) => (
        <TextField {...params} label="Countries" margin="none" />
      )}
      sx={{ minWidth: 200 }}
    />
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel>Status</InputLabel>
      <Select
        value={filters.statusFilter}
        label="Status"
        onChange={(e) => onChangeStatusFilter(e.target.value as StatusFilter)}
        sx={{ height: 43 }}
      >
        {STATUS_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Stack>
);

export default DestinationFilters;
